import { render } from "./index2.vue?vue&type=template&id=4fddcdfe"
import script from "./index2.vue?vue&type=script&lang=ts"
export * from "./index2.vue?vue&type=script&lang=ts"

import "./index2.vue?vue&type=style&index=0&id=4fddcdfe&lang=less"
script.render = render

export default script